import { createRoot } from 'react-dom/client';
import { App } from './App';

const main = () => {
  const container = document.getElementById('root');
  const root = createRoot(container!);
  root.render(<App />);
};

main();
